import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { selectDimensions, useSelector } from '@bonanza-social/toolkit/state';
import { AnimatedCoinsEllipse } from '@bonanza-social/moonlight';
import { selectLoyaltyLevel } from '../../state/levels.slice';

function LevelUpAnimation() {
  const [showAnimation, setShowAnimation] = useState(false);
  const { level } = useSelector(selectLoyaltyLevel) || {};
  const prevLevel = useRef(level);
  const fromPoint = useSelector(selectDimensions('LEVEL_HEADER_ITEM'));
  const toPoint = useSelector(selectDimensions('COIN_BALANCE_HEADER_ITEM'));

  const onAnimationFinish = useCallback(() => {
    setShowAnimation(false);
  }, []);

  useEffect(() => {
    if (level === undefined || prevLevel.current === undefined) {
      prevLevel.current = level;

      return;
    }

    setShowAnimation(level > prevLevel.current);

    prevLevel.current = level;
  }, [level]);

  if (!showAnimation || !fromPoint || !toPoint) {
    return;
  }

  return (
    <AnimatedCoinsEllipse
      fromPoint={fromPoint}
      toPoint={toPoint}
      onAnimationFinish={onAnimationFinish}
    />
  );
}

export default memo(LevelUpAnimation);
